import { ConfigDefaults, BOM, EOL } from '@/assets/constants';

class CsvService {
  csv;
  data;
  _options;

  dataToCsv(sourdeData, filename, options) {
    this.csv = '';
    const config = options || {};
    this.data = sourdeData;
    this._options = { ...ConfigDefaults, ...config };
    if (this._options.filename) {
      this._options.filename = filename;
    }
    this.generateCsv();
  }

  generateCsv() {
    if (this._options.useBom) {
      this.csv += BOM;
    }
    if (this._options.showTitle) {
      this.csv += this._options.title + '\r\n\n';
    }
    this.getHeaders();
    this.getBody();
    if (this.csv == '') {
      console.error('Invalid data');
      return;
    }
    const blob = new Blob([this.csv], { type: 'text/csv;charset=utf8;' });
    if (navigator.msSaveBlob) {
      const filename = this._options.filename.replace(/ /g, '_') + '.csv';
      navigator.msSaveBlob(blob, filename);
    } else {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('visibility', 'hidden');
      link.download = this._options.filename.replace(/ /g, '_') + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  getHeaders() {
    if (this._options.headers.length > 0) {
      let row = '';
      for (let _i = 0, _a = this._options.headers; _i < _a.length; _i++) {
        const column = _a[_i];
        row += column + this._options.fieldSeparator;
      }
      row = row.slice(0, -1);
      this.csv += row + EOL;
    }
  }

  getBody() {
    for (let i = 0; i < this.data.length; i++) {
      let row = '';
      for (const index in this.data[i]) {
        row += this.formatData(this.data[i][index]) + this._options.fieldSeparator;
      }
      row = row.slice(0, -1);
      this.csv += row + EOL;
    }
  }

  formatData(data) {
    if (this._options.decimalseparator === 'locale' && this.isFloat(data)) {
      return data.toLocaleString();
    }
    if (this._options.decimalseparator !== '.' && this.isFloat(data)) {
      return data.toString().replace('.', this._options.decimalseparator);
    }
    if (typeof data === 'string') {
      data = data.replace(/"/g, '""');
      if (
        this._options.quoteStrings ||
        data.indexOf(',') > -1 ||
        data.indexOf('\n') > -1 ||
        data.indexOf('\r') > -1
      ) {
        data = this._options.quoteStrings + data + this._options.quoteStrings;
      }
      return data;
    }
    if (data === undefined) {
      return '';
    }
    if (typeof data === 'boolean') {
      return data ? 'TRUE' : 'FALSE';
    }
    return data;
  }

  isFloat(input) {
    return +input === input && (!isFinite(input) || Boolean(input % 1));
  }
}

const csvService = new CsvService();
export default csvService;
